<div class="flex full-height column">
    <app-navbar></app-navbar>
    <div class="flex-grow-1">
        <router-outlet></router-outlet>
    </div>
</div>